import { createAction, props } from '@ngrx/store';
import { TreeNode } from 'primeng/api';

export const toggleNode = createAction('CategoryTreeToggleNode', props<{ key: string; expanded: boolean }>());

export const selectNode = createAction('CategoryTreeSelectNode', props<{ key: string }>());

export const loadCategoriesSuccess = createAction('CategoryTreeLoadSuccess', props<{ categories: TreeNode[] }>());

export const refreshTree = createAction('CategoryTreeRefresh');
